import { axiosInstanceGeoLocation } from "../instance";


export const getGeoLocation = async () => {
    const response = await axiosInstanceGeoLocation.get(`/geo-location`);
    return response.data;
}